// extracted by mini-css-extract-plugin
module.exports = {"more-btn":"AutoEventsTable_more-btn__1Kq9I","wrapper":"AutoEventsTable_wrapper__zCcIc"};